<template>
<div style="min-height: 750px;">
    <b-row style="margin: 0px;">
      <b-col sm="12" lg="3">
        <b-row>
          <b-col sm="12" lg="12">
            <b-row style="margin-bottom: 10px;">
              <b-col sm="12" lg="6"> </b-col>
              <b-col sm="12" lg="6" style="text-align: right;">
                <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                  <template slot="button-content">
                    {{ StoreLangTranslation.data['process'][StoreLang] }}
                  </template>
                  <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')" @click="f_newUserShopBundleAgreement()"><i class="fa fa-plus"></i> 
                    {{ StoreLangTranslation.data['new_user_shop_bundle_agreement'][StoreLang] }}
                  </b-dropdown-item>

                </b-dropdown>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12" lg="12">
                <b-form-input id="search" v-model="d_searchText" :placeholder="StoreLangTranslation.data['write_for_filtering'][StoreLang]"></b-form-input>
              </b-col>
            </b-row>
            <div style="overflow-x: hidden; overflow-y: auto; height: 750px;">
              <template v-if="d_loading">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </template>
              <template v-else>
                <b-row v-for="(wdmr_item, wdmr_item_ind) in d_usrShpBundleAgreementList" v-if="f_searchList(wdmr_item)" @mouseover="d_hoverIndex = wdmr_item_ind" @mouseleave="d_hoverIndex = ''" :style="wdmr_item.client_id === d_userShopBundleAgreementClientID ? 'cursor: pointer; margin: 10px; border-bottom: solid 1px #dcdcdc; background-color: lightgreen;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc;'">
                  <b-col sm="12" lg="10">

                        <b-row @click="f_editThisUserShopBundleAgreement(wdmr_item.client_id)">
                          <b-col sm="12" lg="12">
                            <strong>
                              <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['lang'] && wdmr_item.data['0']['1']['lang'][StoreLang]">
                                <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['lang'][StoreLang] }}</span>
                              </template>
                              <template v-else-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['1'] && wdmr_item.data['0']['1']['val']">
                                <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['1']['val'] }}</span>
                              </template>
                            
                            </strong>
                          </b-col>
                        </b-row>
                        <b-row @click="f_editThisUserShopBundleAgreement(wdmr_item.client_id)">
                          <b-col sm="12" lg="12">
                                        
                            <template v-if="wdmr_item.data && wdmr_item.data['0'] && wdmr_item.data['0']['0'] && wdmr_item.data['0']['0']['val']['translation']">
                              <span :style="d_hoverIndex === wdmr_item_ind ? ' color: rgb(252, 0, 153, 1);' : ''">{{ wdmr_item.data['0']['0']['val']['translation'][StoreLang] }}</span>
                            </template>
                          </b-col>
                        </b-row>

                  </b-col>
                  <b-col sm="12" lg="2">
<!--                     <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                      <template slot="button-content">
                        {{ StoreLangTranslation.data['process'][StoreLang] }}
                      </template>
                      <b-dropdown-item v-if="ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']) || ClsUser.f_checkUserAuth([d_userShopClientID + '_shop_admin', d_userShopClientID + '_shop_bundle_add_edit'], 'with_id')" @click="f_editThisUserShopBundleAgreement(wdmr_item.client_id)"><i class="fa fa-edit"></i> {{ StoreLangTranslation.data['edit'][StoreLang] }} </b-dropdown-item>
                    </b-dropdown>
                   -->
                  </b-col>

                </b-row>
              </template>
            </div>


          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="9">
        <b-tabs>

          <b-tab  :active="d_selectedTab === 'bundle_agreement_edit'" @click="d_selectedTab = 'bundle_agreement_edit'">
            <template slot="title">
              {{ StoreLangTranslation.data['user_shop_bundle_agreement_record'][StoreLang] }}
            </template>
            <template v-if="d_selectedTab === 'bundle_agreement_edit'">
              <shop-bundle-agreement-record v-if="d_componentShow" :p_userShopClientID="d_userShopClientID" :p_userShopBundleClientID="d_userShopBundleClientID" :p_userShopBundleAgreementClientID="d_userShopBundleAgreementClientID" :f_userShopBundleAgreementList="f_userShopBundleAgreementList"></shop-bundle-agreement-record>
            </template>

          </b-tab>

        </b-tabs>
      </b-col>
    </b-row>

    

  </div>





</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as ShopBundleAgreementRecord
} from '@/wam/components/shop/ShopBundleAgreementRecord';
import { mapGetters } from 'vuex';
export default {
  name: 'ShopBundleAgreementList',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    ShopBundleAgreementRecord,
  },
  props: {
    p_userShopClientID: {
      type: String,
      required: true
    },
    p_userShopBundleClientID: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      d_selectedTab: 'bundle_agreement_edit',
      d_componentShow: false,
      d_loading: false, 
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_userShopClientID: '',
      d_userShopBundleClientID: '',
      d_userShopBundleAgreementClientID: '',
      d_usrShpBundleAgreementList: [],
      // d_usrShpBundAgreementWdm: '',
      ClsUser: ClsUser,
    };
  },
  created: function () {
    this.d_loading = true;
    // ClsWdm.getLayerWdm('usr_shp_bund_agr').then(resp_wdm_data => { this.d_usrShpBundAgreementWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.p_userShopClientID;
    this.d_userShopBundleClientID = this.p_userShopBundleClientID;

    // this.d_userShopClientID = this.$route.query.user_shop_client_id;
    // this.d_userShopBundleClientID = this.$route.query.user_shop_bundle_client_id;

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      this.f_userShopBundleAgreementList();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundAgreementWdm);
  },
  methods: {
    f_newUserShopBundleAgreement: function () {
      this.d_selectedTab = 'bundle_agreement_edit';
      this.d_userShopBundleAgreementClientID = '';
      this.d_componentShow = false;
      setTimeout(function () {
        this.d_componentShow = true;
      }.bind(this), 100)
      // this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_bundle_agreement_record', this.StoreLang), query: { 'user_shop_bundle_client_id': this.d_userShopBundleClientID, 'user_shop_client_id': this.d_userShopClientID } });
    },
    f_editThisUserShopBundleAgreement: function (user_shop_bundle_agreement_client_id) {
      this.d_userShopBundleAgreementClientID = user_shop_bundle_agreement_client_id;
      this.d_componentShow = false;
      setTimeout(function () {
        this.d_componentShow = true;
      }.bind(this), 100)

      // let route_path = ClsRoute.f_getRoutePath('user_shop_bundle_agreement_record', this.StoreLang);
      // // console.log('route_path : ', route_path);
      // this.$router.push({ path: route_path, query: { 'user_shop_bundle_client_id': this.d_userShopBundleClientID, 'user_shop_bundle_agreement_client_id': user_shop_bundle_agreement_client_id, 'user_shop_client_id': this.d_userShopClientID } });
    },
    f_searchList: function (wdmr_item) {
      let res = false;
      if (this.d_searchText) {
        let search_item = '';
        try {
          search_item = wdmr_item.data['0']['1']['lang'][this.StoreLang];
        } catch(err) {}
        if (search_item) {
          if (search_item.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
            res = true;
          }
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userShopBundleAgreementList: function () {
      this.d_loading = true;
      this.d_componentShow = false;
      let query = 'user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      let data = {};
      ServiceFunctions.user_shop_bundle_agreement_list(query, data)
        .then(resp => {
          this.d_componentShow = true;
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_usrShpBundleAgreementList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
  }
};

</script>

